import { AssetWizardFlow } from '@/store/ai/assetWizard/utils/types'

/**
 * Flows that describe the same thing, differing only in what else came with it.
 *
 * A wizard on screen may be switched to another flow in its own family and to
 * nothing else. The flows are not variants of one another: a loan and a
 * property have different fields, different records and different schemas, so
 * "this is a loan, not a property" is not a correction — it is a different
 * question, answered by editing the sentence or going back to Add asset. What
 * *is* a correction is having missed the financing on a purchase, and that is
 * what a family holds.
 *
 * Declared as groups rather than as an `alternatives` list per definition so
 * the relation cannot go one-way: a family is symmetric by construction, and a
 * definition listing a flow that does not list it back is not expressible.
 */
export const WIZARD_FLOW_FAMILIES: AssetWizardFlow[][] = [
  [AssetWizardFlow.REAL_ESTATE, AssetWizardFlow.REAL_ESTATE_WITH_FINANCING],
  [AssetWizardFlow.PRIVATE_FUND, AssetWizardFlow.PRIVATE_FUND_SUBSCRIBE_AND_COMMIT],
]

/**
 * The flows this one may be switched to, itself included, in family order.
 *
 * One entry means there is nothing to switch to — the caller draws a heading
 * rather than a dropdown, because a picker with a single option is a control
 * that cannot do anything.
 */
export const switchableFlows = (flow: AssetWizardFlow): AssetWizardFlow[] =>
  WIZARD_FLOW_FAMILIES.find(family => family.includes(flow)) ?? [flow]
